<template>
  <b-form-group
    :description="description"
    :label="label"
    :invalid-feedback="invalidFeedback"
    :valid-feedback="validFeedback"
    :state="state"
    label-sr-only
    class="al-form-group"
    :class="getClass()"
    test-id="al-form-group"
  >
    <div class="al-form-group__title-label">
      <slot name="label">
        <header v-if="label !== ''" class="inline">
          <strong class="title">{{ label }}</strong>
          <al-icon v-if="tooltip" class="inline" :tooltip="tooltip" icon="help"></al-icon>
          <div v-if="subLabel !== ''" class="subtitle">{{ subLabel }}</div>
        </header>
      </slot>
    </div>

    <div class="content">
      <slot />
    </div>
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue';

export default {
  components: {
    BFormGroup
  },
  props: {
    invalidFeedback: { type: String, default: '' },
    validFeedback: { type: String, default: '' },
    state: { type: String, default: '' },
    description: { type: String, default: '' },
    label: { type: String, default: '' },
    tooltip: { type: String, default: null },
    subLabel: { type: String, default: '' },
    inline: Boolean
  },
  methods: {
    getClass() {
      return [{ inline: this.inline }];
    }
  }
};
</script>

<style lang="scss">
$padding: 24px;

.al-form-group {
  $padding: 24px;
  margin: 0;
  padding-bottom: $padding/2;
  padding-top: $padding/2;

  .title {
    color: color(black, lighten, 1);
    font-size: 12.8px;
    font-weight: bold;
    text-transform: uppercase;
  }

  header {
    line-height: initial;
    margin-bottom: 12px;

    .subtitle {
      color: color(black, lighten, 3);
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 15px;
    }
  }

  &__title-label {
    padding-bottom: $padding/2;

    .inline {
      align-items: center;
      display: inline;
    }
  }

  .text-muted {
    color: color(black, lighten, 3) !important;
  }

  &.right {
    .content {
      justify-content: flex-end;
      text-align: right;
    }
  }

  &.inline {
    .content {
      display: flex;

      > * {
        margin-right: 10px;
      }

      > *:last-child {
        margin-right: 0;
      }
    }
  }

  .al-icon {
    vertical-align: middle;
  }
}

.al-form-group:first-child {
  padding-top: 0;
}
</style>
